/**
 * The app's timezone: Asia/Baghdad (Iraq). Fixed, not configurable.
 *
 * Every date and time on screen is shown in this zone and every time the centre enters (a visit
 * schedule, an invoice time) is sent with it, whatever the device's own clock says. The app never
 * detects or reports the browser's zone. The server stores the same zone for these accounts
 * (`users.timezone`), so the centre's bare wall-clock working hours ("08:00"-"20:00") always mean
 * Baghdad time.
 *
 * IDENTICAL COPY across the centre apps (lab, imaging, physiotherapy, nurse, insurance). Same value
 * as `PLATFORM_TIMEZONE` in tiryaq-healthcare-shared, which the backend uses.
 */
export const PLATFORM_TIMEZONE = "Asia/Baghdad";

/** Kept for existing imports; the same fixed zone. */
export const DEFAULT_TIMEZONE = PLATFORM_TIMEZONE;
